/* Phones get the hourly drop-off step as one full-screen screen (AppModal
   renders no sheet for it there); tablets and up keep the centred sheet. */
export const isHourlyFullScreen = () => window.innerWidth < 768;
